import React from "react";
import { NavLink, Redirect, Route, Switch } from "polyrouter";
import { PolyPlusMockLicenses } from "./MockLicenses/PolyPlusMockLicenses";
import { useTenantQuery } from "generated/graphql";
import { Layout } from "views/Main/Layouts";
import { useTranslation } from "utilities/i18n";
import { PolyPlusSetupRouter } from "./Setup/PolyPlusSetupRouter";
import { useRouteMatch } from "react-router";
import { LicenseKeysRouter } from "../Shared/LicenseKeys/LicenseKeysRouter";
import { LicenseDetails } from "../Shared/LicenseKeys/Details/LicenseDetails";
import { useTenantId } from "polyrouter/SelectedTenantProvider";

export const PolyPlusRouter: React.FC = () => {
  const { t } = useTranslation();
  const tenantId = useTenantId();
  const { data } = useTenantQuery({ variables: { id: tenantId } });
  const isMockLicenseTenant = data?.tenant?.mockLicenseTenant;
  const isDetailsView = !!useRouteMatch(
    "/manage/licensing/poly-plus/license-keys/details"
  );
  const isMockDetailsView = !!useRouteMatch(
    "/manage/licensing/poly-plus/mock-licenses/details"
  );

  const back = (() => {
    if (isDetailsView) {
      return {
        to: "/manage/licensing/poly-plus/license-keys",
        title: t("LICENSE_KEYS"),
        iconDesc: t("LICENSE_KEYS")
      };
    }

    if (isMockDetailsView) {
      return {
        to: "/manage/licensing/poly-plus/mock-licenses",
        title: t("POLY_PLUS_GENERATION_TITLE"),
        iconDesc: t("POLY_PLUS_GENERATION_TITLE")
      };
    }

    return {
      to: "/manage/licensing/",
      title: t("LICENSING"),
      iconDesc: t("LICENSING")
    };
  })();

  const { Sidebar } = Layout;

  return (
    <Layout back={back}>
      {!isDetailsView && !isMockDetailsView && (
        <Sidebar>
          <span className="title-capitalized">{t("POLY_PLUS")}</span>
          <ul className="menu router">
            <li>
              <NavLink nest to="/setup">
                {t("SETUP")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/license-keys">
                {t("LICENSE_KEYS")}
              </NavLink>
            </li>
            {isMockLicenseTenant && (
              <li>
                <NavLink nest to="/mock-licenses">
                  {t("POLY_PLUS_GENERATION_TITLE")}
                </NavLink>
              </li>
            )}
          </ul>
        </Sidebar>
      )}
      <Switch nest>
        <Route path="/setup">
          <PolyPlusSetupRouter />
        </Route>
        {isMockLicenseTenant && (
          <Route path="/mock-licenses/details/:licenseKey">
            <LicenseDetails />
          </Route>
        )}
        {isMockLicenseTenant && (
          <Route path="/mock-licenses">
            <PolyPlusMockLicenses tenantId={tenantId} />
          </Route>
        )}
        <Route path="/license-keys">
          <LicenseKeysRouter />
        </Route>
        <Redirect nest to="/setup" />
      </Switch>
    </Layout>
  );
};
